import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import styles from './style.module.css'
import { ChangeEvent } from 'react'

interface SectionDropdownProps {
  label: string
  defaultValue: string
  onChange: (itemKey: string) => void
  items: Array<{ key: string; value: string }>
  placeholder?: string
  disabled?: boolean
}

function PrimaryDropdown({
  label,
  defaultValue,
  onChange,
  items,
  placeholder = 'Select an option',
  disabled = false,
}: SectionDropdownProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    onChange(newValue)
  }

  return (
    <div>
      <TextField
        label={label}
        select
        fullWidth
        value={defaultValue}
        onChange={handleChange}
        disabled={disabled}
        sx={{ minWidth: 150 }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 500,
              },
            },
          },
        }}
      >
        <MenuItem
          value=''
          disabled
        >
          {placeholder}
        </MenuItem>
        {items.map(({ key, value }) => (
          <MenuItem
            key={key}
            value={key}
          >
            <span className={styles.menuItemContent}>{value}</span>
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}

export default PrimaryDropdown
